export enum EditionType {
  CLONE = 'CLONE',
  BIKE_IMAGES = 'BIKE_IMAGES',
  BIKE_DETAIL = 'BIKE_DETAIL',
  BIKE_PARTS = 'BIKE_PARTS',
  BIKE_LOCATION = 'BIKE_LOCATION'
}

